import React, { useEffect } from 'react';
import { getPoSubTypes } from '../api/purchaseOrders';
import { useGlobalContext } from '../context/global/GlobalContext';
import { useUserPermissions } from '../context/permission/PermissionsProvider';
import { setPoSubTypesAction } from '../context/poSubTypes/poSubTypesActions';
import { orderByField } from '../utils/utils';

export const PoSubTypesFetcher = () => {
  const { dispatch } = useGlobalContext();

  const { canSelectPoSubType } = useUserPermissions();

  useEffect(() => {
    const data = getPoSubTypes?.data ?? [];

    if (canSelectPoSubType && data.length > 0) {
      dispatch(setPoSubTypesAction(orderByField('label', data)));
    }
  }, [canSelectPoSubType, dispatch]);

  return <></>;
};
